module.exports = __webpack_public_path__ + "img/@logo_logen_co@3x.7d36da1e.png";